<script lang="ts">

/**
 * VDataGridContextMenuV2 — декларативный компонент контекстного меню
 *
 * Появляется при правом клике на строку.
 * Доступная переменная: row
 *
 * @example
 * <VDataGridContextMenuV2>
 *   <VButton @click="edit(row)">Редактировать</VButton>
 *   <VButton @click="delete(row)">Удалить</VButton>
 * </VDataGridContextMenuV2>
 */
export default defineComponent({
  name: 'VDataGridContextMenuV2',

  render() {
    return null;
  },
});
</script>
